import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSchedules,
  fetchSchedule,
  updateSchedule,
  deleteSchedule,
  fetchAuditSchedule,
  createSchedule,
  fetchSessionsBySchedule,
  fetchSession,
  startSession,
  pauseSession,
  finishSession,
  addNewSession,
  deleteSession,
  //fetchSessionsByUser,
  fetchAnswersBySession,
  fetchResultsBySession,
  postAnswer,
  endSessionHandle,
  fetchMarks,
  fetchOrganisation,
  // postQuestionFlag
  fetchCandidateSessions,
} from "../Actions/SessionsActions";
import { getIncorrectQuestions } from "../../../Utilities/tools";

const initialState = {
  schedules: [],
  schedule: {},
  scheduleAudit: [],
  sessions: [],
  session: {},
  answers: [],
  marks: [],
  answersSaved: JSON.parse(sessionStorage.getItem("answers")) || [],
  questions: [],
  onlyWrongQuestions: [],
  result: null,
  loading: true,
  finished: null,
  taggedQuestions: JSON.parse(sessionStorage.getItem("taggedQuestions")) || [],
  sessionStatus: sessionStorage.getItem("sessionStatus") || null, //pending, started, paused or finished
  scheduleStatus: sessionStorage.getItem("scheduleStatus") || null, //pending, live or finished
  statusPause: null,
  starttime: null,
  laststarttime: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {
    hideError(state, action) {
      return {
        ...state,
        status: "idle",
        error: null,
      };
    },
    setSessionStatus(state, action) {
      return {
        ...state,
        sessionStatus: action.payload,
      };
    },
    tagQuestion(state, action) {
      let newTaggedQuestions =
        JSON.parse(sessionStorage.getItem("taggedQuestions")) || [];
      const qid = action.payload.qid;

      if (newTaggedQuestions.includes(qid)) {
        newTaggedQuestions = newTaggedQuestions.filter((id) => id !== qid);
      } else {
        newTaggedQuestions.push(qid);
      }

      sessionStorage.setItem(
        "taggedQuestions",
        JSON.stringify(newTaggedQuestions),
      );
      return {
        ...state,
        taggedQuestions: newTaggedQuestions,
        error: null,
      };
    },
    completePage(state, action) {
      let newStatePages = [...state.pages];
      const index = newStatePages.findIndex((page) => {
        return (
          page.page === action.payload.page &&
          page.section === action.payload.section
        );
      });
      newStatePages[index] = { ...newStatePages[index], completed: true };

      sessionStorage.setItem("pages", JSON.stringify(newStatePages));
      return {
        ...state,
        pages: newStatePages,
        error: null,
      };
    },
    markPagesAsCompleted(state, action) {
      let newStatePages = [...state.pages];
      const completedQuestions = [...state.answersSaved];

      if (completedQuestions.length > 0) {
        completedQuestions.forEach((question) => {
          const index = newStatePages.findIndex((page) => {
            return page.qhid === question.qhid;
          });
          newStatePages[index] = { ...newStatePages[index], completed: true };
        });
      }

      sessionStorage.setItem("pages", JSON.stringify(newStatePages));
      return {
        ...state,
        pages: newStatePages,
        error: null,
      };
    },
    savePages(state, action) {
      let countedPages = JSON.parse(sessionStorage.getItem("pages")) || [];

      return {
        ...state,
        pages: countedPages,
        error: null,
      };
    },

    newAnswer(state, action) {
      let newState = state.answersSaved.filter(
        (answer) => answer.qid !== action.payload.qid,
      );

      sessionStorage.setItem(
        "answers",
        JSON.stringify([...newState, action.payload]),
      );

      return {
        ...state,
        status: "succeeded",
        answersSaved: [...newState, action.payload],
        error: null,
      };
    },

    newAnswerTwo(state, action) {
      let newState = state.answersSaved.filter(
        (answer) => answer.qid !== action.payload.qid,
      );

      sessionStorage.setItem(
        "answers",
        JSON.stringify([...newState, action.payload]),
      );

      return {
        ...state,
        status: "succeeded",
        answersSaved: [...newState, action.payload],
        error: null,
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCandidateSessions.fulfilled, (state, action) => {
        state.status = "succeeded";
        sessionStorage.setItem("result", JSON.stringify(null));
        state.result = null;
        state.error = null;
      })
      .addCase(fetchCandidateSessions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchCandidateSessions.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchSession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.session = action.payload;
        state.statusPause = action.payload.pauseleft ? true : false;
        state.starttime = action.payload.schedule.starttime;
        state.laststarttime = action.payload.schedule.laststarttime;
        state.scheduleStatus = action.payload.schedule.status;
        sessionStorage.setItem("sessionStatus", action.payload.status);
        state.sessionStatus = action.payload.status;
        state.answers = [];
        state.questions = [];
      })
      .addCase(fetchSession.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchSession.pending, (state, action) => {
        state.status = "loading";
      })

      .addCase(startSession.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchSchedules.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchSchedules.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.schedules = action.payload;
      })
      .addCase(fetchSchedules.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchSchedule.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.schedule = action.payload;
      })
      .addCase(fetchSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateSchedule.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteSchedule.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(deleteSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(deleteSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(fetchAuditSchedule.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchAuditSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.scheduleAudit = action.payload;
      })
      .addCase(fetchAuditSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchSessionsBySchedule.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchSessionsBySchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessions = action.payload;
      })
      .addCase(fetchSessionsBySchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(startSession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessionStatus = "started";
      })
      .addCase(startSession.rejected, (state, action) => {
        state.status = "failed";
        state.sessionStatus = "pending";
        state.error = action.payload;
      })
      .addCase(pauseSession.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(pauseSession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessionStatus = "paused";
      })
      .addCase(pauseSession.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(finishSession.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(finishSession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessionStatus = "finished";
      })
      .addCase(finishSession.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createSchedule.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(createSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.schedules.push({});
      })
      .addCase(addNewSession.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(addNewSession.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(addNewSession.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(deleteSession.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(deleteSession.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteSession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessions = state.sessions.filter(
          (session) => session.user.userid !== action.payload,
        );
      })
      .addCase(fetchAnswersBySession.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchAnswersBySession.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.answers = [];
        state.loading = false;
        state.result = null;
        sessionStorage.setItem("result", JSON.stringify(null));
      })
      .addCase(fetchAnswersBySession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.answers = action.payload.data;
        state.answersSaved = action.payload.data;
        state.finished = action.payload.data.finished;
        state.questions = action.payload.data.questions;
        state.loading = false;
      })
      .addCase(fetchResultsBySession.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(fetchResultsBySession.rejected, (state, action) => {
        state.status = "rejected";
      })
      .addCase(fetchResultsBySession.fulfilled, (state, action) => {
        state.status = "succeeded";
        const result = action.payload.data.result;
        state.result = result;
        sessionStorage.setItem("result", JSON.stringify(result));
        state.finished = action.payload.data.finished;
        state.questions = action.payload.data.questions;
        state.onlyWrongQuestions = getIncorrectQuestions(
          action.payload.data.questions,
          action.payload.data.answers,
        );
        state.loading = false;
      })
      .addCase(postAnswer.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(postAnswer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(postAnswer.fulfilled, (state, action) => {
        state.status = "succeeded";
        const newAnswer = action.payload;
        if (!newAnswer) return;

        const existing = state.answersSaved.find(
          (a) => a.qid === newAnswer.qid,
        );
        let updatedAnswers;

        if (
          newAnswer.answercontent?.multichoice &&
          Array.isArray(newAnswer.answercontent.multichoice)
        ) {
          if (existing) {
            const existingIds = existing.answercontent.multichoice || [];
            const incomingIds = newAnswer.answercontent.multichoice;

            const merged = Array.from(
              new Set([...existingIds, ...incomingIds]),
            );

            const updated = {
              ...existing,
              answercontent: {
                ...existing.answercontent,
                multichoice: merged,
              },
            };

            updatedAnswers = state.answersSaved.map((a) =>
              a.qid === newAnswer.qid ? updated : a,
            );
          } else {
            updatedAnswers = [...state.answersSaved, newAnswer];
          }
        } else {
          const filtered = state.answersSaved.filter(
            (a) => a.qid !== newAnswer.qid,
          );
          updatedAnswers = [...filtered, newAnswer];
        }

        sessionStorage.setItem("answers", JSON.stringify(updatedAnswers));
        state.answersSaved = updatedAnswers;
      })
      .addCase(endSessionHandle.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(endSessionHandle.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(endSessionHandle.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(fetchMarks.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchMarks.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchMarks.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.marks = action.payload;
      })
      .addCase(fetchOrganisation.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchOrganisation.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchOrganisation.fulfilled, (state, action) => {
        state.status = "succeeded";
      });
  },
});

export const {
  hideError,
  newAnswer,
  newAnswerTwo,
  tagQuestion,
  completePage,
  markPagesAsCompleted,
  savePages,
  setSessionStatus,
} = sessionsSlice.actions;

export default sessionsSlice.reducer;
